<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/orLGA6/tc-custom/9781459209954.jpg?1723231591437" alt="This image is the cover for the book Buried Truth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Buried Truth
      </h1>
      <p class="bookDescription body article font2">
        <b>With a killer on the loose, a Native American detective must protect his community—and the woman he once loved—in this suspenseful romance.</b><br/><br/>A note, impaled by a knife on Bill Cloudman’s door, tells the former tribal agent a murderer has escaped. The vicious madman who murdered Bill’s partner—and cost Bill his job and the community’s trust—is on the loose in the South Dakota badlands again. Now Bill is determined to put him behind bars once and for all.<br/><br/>Meanwhile, the woman Bill loved and lost has returned to Eagle Rock reservation. Now working as a newspaper reporter, she is equally determined to restore her own reputation—with the story of the escaped killer. With everything on the line, Bill will do whatever it takes to protect her . . . and his guarded heart.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dana Mentink
      </h2>
      
      <p class="authorDescription body article">Dana Mentink&#160;is a Publisher&#39;s Weekly and national bestselling author. She has been honored to win two Carol Awards, a Holt Medallion and a Reviewer&#39;s Choice award. She&#39;s authored more than&#160;thirty five novels to date for Harlequin&rsquo;s Love Inspired Suspense and Harlequin&#160;Heartwarming. Dana loves feedback from her readers. Contact her at www.danamentink.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f27c4ff